import { type SentryClientInterface } from '@capsicum/common';
import * as Sentry from '@sentry/nextjs';

// No need to re-init Sentry since it's being handled by sentry.client/server/edge.config.js files
export class SentryWebService implements SentryClientInterface {
	captureException(error: Error, extra?: object) {
		return Sentry.captureException(error, extra);
	}

	captureMessage(message: string, level: Sentry.SeverityLevel) {
		return Sentry.captureMessage(message, level);
	}

	captureExceptionMessage(message: string, meta?: Record<string, any>) {
		return Sentry.captureMessage(message, scope => {
			scope.setLevel('error');
			scope.setTags(meta?.tags ?? {});
			scope.setExtras(meta?.extras ?? {});

			if (meta?.error instanceof Error) {
				scope.captureException(meta.error, meta.extras);
			}

			return scope;
		});
	}

	setUser(user: Sentry.User) {
		Sentry.setUser(user);
	}
}
